import { AxiosResponse } from 'axios';
import { PengajuanJenisPelatihan } from '../../entities/PengajuanJenisPelatihan';

export class PengajuanJenisPelatihanDataMapper {
  public convertPengajuanJenisPelatihanDataFromApi(
    result: AxiosResponse<any>
  ): PengajuanJenisPelatihan[] {
    const { data } = result.data;

    let pengajuanJenisPelatihan: PengajuanJenisPelatihan[] = [];

    data.map((pjp: any) => {
      return pengajuanJenisPelatihan.push(
        new PengajuanJenisPelatihan(
          pjp.id,
          pjp.sub_menu_jenis_pelatihan_id,
          pjp.kode,
          pjp.nama_pelatihan,
          pjp.waktu_mulai,
          pjp.waktu_selesai,
          pjp.kompetensi,
          pjp.jp,
          pjp.keterangan,
          pjp.status_pengajuan,
          pjp.alasan,
          pjp.created_at,
          pjp.updated_at,
          result.data.pagination.total_rows
        )
      );
    });

    return pengajuanJenisPelatihan;
  }

  public convertDetailPengajuanJenisPelatihanDataFromApi(
    result: AxiosResponse<any>
  ): PengajuanJenisPelatihan {
    const { data } = result.data;

    let pengajuanJenisPelatihan: PengajuanJenisPelatihan;

    pengajuanJenisPelatihan = new PengajuanJenisPelatihan(
      data.id,
      data.sub_menu_jenis_pelatihan_id,
      data.kode,
      data.nama_pelatihan,
      data.waktu_mulai,
      data.waktu_selesai,
      data.kompetensi,
      data.jp,
      data.keterangan,
      data.status_pengajuan,
      data.alasan,
      data.created_at,
      data.updated_at,
      0
    );

    return pengajuanJenisPelatihan;
  }
}
